












































import { Component, Vue } from 'vue-property-decorator'
import GroupHeader from '@/components/Group/GroupHeader.vue'
import { EGroupRegisterType } from '@/models'
import GroupMemberService from '@/services/GroupMemberService'
import GroupService from '@/services/GroupService'
import { ERR_API_KEY } from '@/constants'
import {getModule} from "vuex-module-decorators";
import store from "@/store";
import UserInfo from "@/store/modules/UserInfo";
const UserModule = getModule(UserInfo, store)

@Component({ components: { GroupHeader } })
export default class GroupPreview extends Vue {
  private errorMess: string = ''
  private groupName: string = ''
  created() {
    this.getGroupDetail()
  }

  getGroupDetail() {
    GroupService.checkGroupLink(this.$route.params.groupLink)
      .then(res => {
        if (res.status === 200) {
          this.groupName = res.data.name
        }
      })
      .catch(() => {
        this.$router.push({
          name: 'page-not-found',
          params: { msgCode: 'group_qr_expried' }
        })
      })
  }

  jumpToRegisterPage() {
    const loginedUserId = this.$store.state.userInfo.user.info.id
    if (loginedUserId) {
      GroupMemberService.requestJoin({
        user_id: loginedUserId,
        group_link: this.$route.params.groupLink,
        not_check_belong_group: true
      })
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$bvModal.show('modal-success')
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            if (error.response.data.message === ERR_API_KEY.USER_NOT_BELONG_TO_COMPANY) {
              this.errorMess = this.$t(`common.message.${error.response.data.message}`).toString()
            } else {
              this.errorMess = this.$t('common.message.already_in_group').toString()
            }
            this.$bvModal.show('modal-error')
          }
        })
    } else {
      this.$router.push({
        name: 'register',
        query: {
          type: String(EGroupRegisterType.USER_TEPM_REGISTER),
          group: this.$route.params.groupLink
        }
      })
    }
  }

  jumpToHome() {
    this.$router.push({ name: 'home' })
  }
}
